import { Layout, Button, Typography, Flex } from "antd";
import { Outlet, Link, useLocation } from "react-router-dom";
import CustomIcon from "../components/layouts/CustomIcon";
import { PARTICIPANT_HUB_NAME } from "../actions/constants";

const { Content, Header } = Layout;

export default function ParticipantsLayout() {
  const { state } = useLocation();

  return (
    <Layout className='h-100'>
      <Header className='h-52px lh-1 p-8-24px'>
        <Flex gap={8} align='center' className='h-100'>
          <Link to={state?.from || "/"}>
            <Button type='text' icon={<CustomIcon name='arrow_left' width={24} height={24} rootClassName='color-6C6C89' />} />
          </Link>
          <Typography.Title level={5} className='m-0 font-size-14px fw-600 color-121217 inter'>
            {PARTICIPANT_HUB_NAME}
          </Typography.Title>
        </Flex>
      </Header>
      <Content className='bg-F5F6F9 h-100' style={{ padding: "0 40px", overflow: "auto" }}>
        <Outlet />
      </Content>
    </Layout>
  );
}
